import { Navigate, useLocation } from "react-router-dom";
import { routesByRole } from "../config/routes";

const RoleRouteGuard = ({ children }) => {

    const role = localStorage.getItem("currentRole");
    const location = useLocation();

    const allowedRoutes = routesByRole[role] || [];

    const isAllowed = allowedRoutes.some(route => {
        const basePath = route.path.replace(/:\w+/g, "");
        return location.pathname.startsWith(basePath);
    });

    if (!isAllowed) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default RoleRouteGuard;